import { Link } from '../components/Link';

export function PrivacyContent() {
  return (
    <div>
      <div className="secondary-text">
        This privacy policy has been compiled to better serve those who are concerned with how their
        &apos;Personally Identifiable Information&apos; (PII) is being used online. PII, as described
        in US privacy law and information security, is information that can be used on its own or
        with other information to identify, contact, or locate a single person, or to identify an
        individual in context. Please read our privacy policy carefully to get a clear understanding
        of how we collect, use, protect or otherwise handle your Personally Identifiable Information
        in accordance with our website.
        <br />
      </div>
      <br />
      <b>
        <div>Refunds</div>
      </b>
      <br />
      <div className="secondary-text">
        Any purchases made on this store come with a strict non-refundable policy.
        <br />
        In the event of attempts to bypass our refund policy via filling a dispute with Stripe and/or
        your credit card company, your access to the network and possibly anything related (website,
        store, teamspeak, Game Server) will be revoked.
        <br />
      </div>
      <br />
      <div style={{ clear: 'both', height: 10 }} />
      <div className="grayText">
        <strong>
          What personal information do we collect from the people that visit our blog, website or
          app?
        </strong>
      </div>
      <br />
      <div className="secondary-text">
        When ordering or registering on our site, as appropriate, you may be asked to enter your
        name, email address, mailing address, phone number or other details to help you with your
        experience.
      </div>
      <br />
      <div className="grayText">
        <strong>When do we collect information?</strong>
      </div>
      <br />
      <div className="secondary-text">
        We collect information from you when you register on our site, place an order, Open a Support
        Ticket or enter information on our site.
      </div>
      <br />
      <br />
      <div className="grayText">
        <strong>How do we use your information?</strong>
      </div>
      <br />
      <div className="secondary-text">
        We may use the information we collect from you when you register, make a purchase, sign up
        for our newsletter, respond to a survey or marketing communication, surf the website, or use
        certain other site features in the following ways:
        <br />
        <br />
      </div>
      <div className="secondary-text">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <strong>•</strong> To allow us to better service you in
        responding to your customer service requests.
      </div>
      <div className="secondary-text">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <strong>•</strong> To quickly process your transactions.
      </div>
      <div className="secondary-text">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <strong>•</strong> To follow up with them after
        correspondence (live chat, email or phone inquiries)
      </div>
      <br />
      <div className="grayText">
        <strong>How do we protect your information?</strong>
      </div>
      <br />
      <div className="secondary-text">
        We do not use vulnerability scanning and/or scanning to PCI standards.
      </div>
      <div className="secondary-text">
        We only provide articles and information. We never ask for credit card numbers.
      </div>
      <div className="secondary-text">
        We do not use Malware Scanning.
        <br />
        <br />
      </div>
      <div className="secondary-text">
        Your personal information is contained behind secured networks and is only accessible by a
        limited number of persons who have special access rights to such systems, and are required to
        keep the information confidential. In addition, all sensitive/credit information you supply is
        encrypted via Secure Socket Layer (SSL) technology.
      </div>
      <br />
      <div className="secondary-text">
        We implement a variety of security measures when a user places an order enters, submits, or
        accesses their information to maintain the safety of your personal information.
      </div>
      <br />
      <div className="secondary-text">
        All transactions are processed through a gateway provider and are not stored or processed on
        our servers.
      </div>
      <br />
      <div className="grayText">
        <strong>Do we use &apos;cookies&apos;?</strong>
      </div>
      <br />
      <div className="secondary-text">
        Yes. Cookies are small files that a site or its service provider transfers to your
        computer&apos;s hard drive through your Web browser (if you allow) that enables the
        site&apos;s or service provider&apos;s systems to recognize your browser and capture and
        remember certain information. For instance, we use cookies to help us remember and process the
        items in your shopping cart. They are also used to help us understand your preferences based
        on previous or current site activity, which enables us to provide you with improved services.
        We also use cookies to help us compile aggregate data about site traffic and site interaction
        so that we can offer better site experiences and tools in the future.
      </div>
      <div className="secondary-text">
        <br />
        <strong>We use cookies to:</strong>
      </div>
      <div className="secondary-text">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <strong>•</strong> Understand and save user&apos;s preferences
        for future visits.
      </div>
      <div className="secondary-text">
        <br />
        You can choose to have your computer warn you each time a cookie is being sent, or you can
        choose to turn off all cookies. You do this through your browser settings. Since browser is a
        little different, look at your browser&apos;s Help Menu to learn the correct way to modify
        your cookies.
        <br />
      </div>
      <div className="secondary-text">
        <br />
        <strong>If users disable cookies in their browser:</strong>
      </div>
      <br />
      <div className="secondary-text">
        If you turn cookies off, Some of the features that make your site experience more efficient
        may not function properly.Some of the features that make your site experience more efficient
        and may not function properly.
      </div>
      <br />
      <br />
      <div className="grayText">
        <strong>Third-party disclosure</strong>
      </div>
      <br />
      <div className="secondary-text">
        We do not sell, trade, or otherwise transfer to outside parties your Personally
        Identifiable Information.
      </div>
      <br />
      <div className="grayText">
        <strong>Third-party links</strong>
      </div>
      <br />
      <div className="secondary-text">
        We do not include or offer third-party products or services on our website.
      </div>
      <br />
      <div className="blueText">
        <strong>Google</strong>
      </div>
      <br />
      <div className="secondary-text">
        Google&apos;s advertising requirements can be summed up by Google&apos;s Advertising
        Principles. They are put in place to provide a positive experience for users.
        https://support.google.com/adwordspolicy/answer/1316548?hl=en
        <br />
        <br />
      </div>
      <div className="secondary-text">We do not use Google AdSense Advertising on our website.</div>
      <div className="secondary-text">
        <br />
        <strong>We have implemented the following:</strong>
      </div>
      <br />
      <div className="secondary-text">
        We, along with third-party vendors such as Google use first-party cookies (such as the Google
        Analytics cookies) and third-party cookies (such as the DoubleClick cookie) or other
        third-party identifiers together to compile data regarding user interactions with ad
        impressions and other ad service functions as they relate to our website.
      </div>
      <div className="secondary-text">
        <br />
        <strong>Opting out:</strong>
        <br />
        Users can set preferences for how Google advertises to you using the Google Ad Settings
        page. Alternatively, you can opt out by visiting the Network Advertising Initiative Opt Out
        page or by using the Google Analytics Opt Out Browser add on.
      </div>
      <br />
      <div className="blueText">
        <strong>California Online Privacy Protection Act</strong>
      </div>
      <br />
      <div className="secondary-text">
        CalOPPA is the first state law in the nation to require commercial websites and online
        services to post a privacy policy. The law&apos;s reach stretches well beyond California to
        require any person or company in the United States (and conceivably the world) that operates
        websites collecting Personally Identifiable Information from California consumers to post a
        conspicuous privacy policy on its website stating exactly the information being collected and
        those individuals or companies with whom it is being shared. - See more at:
        http://consumercal.org/california-online-privacy-protection-act-caloppa/#sthash.0FdRbT51.dpuf
        <br />
      </div>
      <div className="secondary-text">
        <br />
        <strong>According to CalOPPA, we agree to the following:</strong>
        <br />
      </div>
      <div className="secondary-text">Users can visit our site anonymously.</div>
      <div className="secondary-text">
        Once this privacy policy is created, we will add a link to it on our home page or as a
        minimum, on the first significant page after entering our website.
        <br />
      </div>
      <div className="secondary-text">
        Our Privacy Policy link includes the word &apos;Privacy&apos; and can easily be found on the
        page specified above.
      </div>
      <div className="secondary-text">
        <br />
        You will be notified of any Privacy Policy changes:
      </div>
      <div className="secondary-text">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <strong>•</strong> On our Privacy Policy Page
        <br />
      </div>
      <div className="secondary-text">Can change your personal information:</div>
      <div className="secondary-text">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <strong>•</strong> By logging in to your account
      </div>
      <div className="secondary-text">
        <br />
        <strong>How does our site handle Do Not Track signals?</strong>
        <br />
      </div>
      <div className="secondary-text">
        We honor Do Not Track signals and Do Not Track, plant cookies, or use advertising when a Do
        Not Track (DNT) browser mechanism is in place.
      </div>
      <div className="secondary-text">
        <br />
        <strong>Does our site allow third-party behavioral tracking?</strong>
        <br />
      </div>
      <div className="secondary-text">
        It&apos;s also important to note that we allow third-party behavioral tracking
      </div>
      <br />
      <div className="blueText">
        <strong>COPPA (Children Online Privacy Protection Act)</strong>
      </div>
      <br />
      <div className="secondary-text">
        When it comes to the collection of personal information from children under the age of 13
        years old, the Children&apos;s Online Privacy Protection Act (COPPA) puts parents in control.
        The Federal Trade Commission, United States&apos; consumer protection agency, enforces the
        COPPA Rule, which spells out what operators of websites and online services must do to protect
        children&apos;s privacy and safety online.
        <br />
        <br />
      </div>
      <div className="secondary-text">
        We do not specifically market to children under the age of 13 years old.
      </div>
      <br />
      <div className="blueText">
        <strong>Fair Information Practices</strong>
      </div>
      <br />
      <div className="secondary-text">
        The Fair Information Practices Principles form the backbone of privacy law in the United
        States and the concepts they include have played a significant role in the development of
        data protection laws around the globe. Understanding the Fair Information Practice Principles
        and how they should be implemented is critical to comply with the various privacy laws that
        protect personal information.
        <br />
        <br />
      </div>
      <div className="secondary-text">
        <strong>
          In order to be in line with Fair Information Practices we will take the following responsive
          action, should a data breach occur:
        </strong>
      </div>
      <div className="secondary-text">We will notify you via email</div>
      <div className="secondary-text">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <strong>•</strong> Within 1 business day
      </div>
      <div className="secondary-text">
        <br />
        We also agree to the Individual Redress Principle which requires that individuals have the
        right to legally pursue enforceable rights against data collectors and processors who fail
        to adhere to the law. This principle requires not only that individuals have enforceable rights
        against data users, but also that individuals have recourse to courts or government agencies
        to investigate and/or prosecute non-compliance by data processors.
      </div>
      <br />
      <div className="blueText">
        <strong>Toplist Used</strong>
      </div>
      <br />
      <div className="secondary-text">
        We use Runelocus and Rspstoplist as our RSPS voting sites found at{' '}
        <a style={{ marginLeft: 0 }} href="https://rspstoplist.com/">
          https://rspstoplist.com/
        </a>
        <br />
        <br />
      </div>
      <br />
      <div className="blueText">
        <strong>Contacting Us</strong>
      </div>
      <br />
      <div className="secondary-text">
        If there are any questions regarding this privacy policy, you may contact us using the
        information below.
        <br />
        <br />
      </div>
      <Link to="/contact">Contact Us</Link>
      <div className="secondary-text">
        <br />
        Last edited on 26th August, 2021
      </div>
    </div>
  );
}
